import { render, staticRenderFns } from "./MenuGrouperCreator.vue?vue&type=template&id=2e12df18"
import script from "./MenuGrouperCreator.vue?vue&type=script&lang=js"
export * from "./MenuGrouperCreator.vue?vue&type=script&lang=js"
import style0 from "./MenuGrouperCreator.vue?vue&type=style&index=0&id=2e12df18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports